module.exports = __webpack_public_path__ + "static/media/Restoration_Hardware.d2c22ef2.png";


//////////////////
// WEBPACK FOOTER
// ./src/modules/pdf/templates/vlp/images/restoration-hardware/Restoration_Hardware.png
// module id = 287
// module chunks = 10